import * as React from "react";
const SvgPastryChef = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 61, height: 51, viewBox: "0 0 61 51", fill: "none", ...props }, "...");
export default SvgPastryChef;
